import { IGetData } from './../in-memory-data.service';

export class NominatimMock implements IGetData {
    getData(payload: any, db?: any): any {
        const nominatimService = db['nominatimService'];
        return nominatimService;
    }
}
